import { CookieService } from './cookie-service';
import * as Cookies from '../constants/cookies';
import * as AuthConstants from '../authentication/constants';

class AuthenticationServiceClass {
  isAuth0Authenticated = () =>
    CookieService.getCookieValue(Cookies.Auth0IsAuthenticated) === 'true' ||
    CookieService.getCookieValue(Cookies.getAuth0IsClientAuthenticated()) === 'true' ||
    CookieService.getCookieValue(Cookies.AccessTokenV3);

  isNativeAuthenticated = () => {
    const val = CookieService.getCookieValue(Cookies.LegacyAuth);
    return val && val !== 'undefined';
  };

  isAuthenticated() {
    const isAuth0Authenticated = this.isAuth0Authenticated();
    const isLegacyAuthenticated = this.isNativeAuthenticated();
    return isAuth0Authenticated || isLegacyAuthenticated;
  }

  getAuthority() {
    if (this.isAuth0Authenticated()) {
      return AuthConstants.IssuingAuthorityAuth0;
    }
    if (this.isNativeAuthenticated()) {
      return AuthConstants.IssuingAuthorityNative;
    }
    return AuthConstants.IssuingAuthorityNone;
  }
}

export const AuthenticationService = new AuthenticationServiceClass();
